import { useAIAgentChat } from '@/contexts/ai-agents';
import { useUser } from '@/hooks/auth/use-user';
import { useUnifiedProfileData } from './use-unified-profile-data';

/**
 * Optimized profile data hook that uses unified dashboard data when available
 * Falls back to separate profile query only when needed
 */
export const useProfileData = () => {
  // Try to get profile data from unified dashboard query first
  const aiAgentContext = useAIAgentChat();
  const unifiedProfileData = aiAgentContext?.dashboardData?.profileData;
  
  // Only use separate profile query if unified data is not available
  const { profileData: separateProfileData, isLoading: separateLoading, error, refetch } = useUnifiedProfileData();
  
  // Use unified data if available, otherwise fall back to separate query
  const profileData = unifiedProfileData || separateProfileData;
  const isLoading = unifiedProfileData ? false : separateLoading;
  
  return { 
    profileData, 
    isLoading, 
    error,
    refetch
  };
};
